export const wrapToLoadingFn = async function wrapToLoadingFn({
  req,
  multiSpinnerItem,
  noLoadingIndicators = false,
  loadingFlagName,
  loadingSpinnerType,
  onSuccess,
  onReject,
  onFinally,
}) {
  if (!noLoadingIndicators) {
    if (multiSpinnerItem) {
      this.$_addElementToSpinnersList(multiSpinnerItem);
    } else if (loadingFlagName) {
      this[loadingFlagName] = true;
    } else {
      this.$VBlackerTheme.openLoadingSpinner(loadingSpinnerType);
    }
  }

  try {
    const response = await req();
    if (onSuccess) {
      await onSuccess(response);
    }
  } catch (e) {
    if (onReject) {
      onReject(e);
    } else {
      this.$VBlackerTheme.notification.error(e.msg || `${e}`);
    }
  } finally {
    if (onFinally) {
      onFinally();
    } else if (multiSpinnerItem) {
      this.$_deleteElementFromSpinnersList(multiSpinnerItem);
    } else if (loadingFlagName) {
      this[loadingFlagName] = false;
    } else {
      this.$VBlackerTheme.closeLoadingSpinner();
    }
  }
};
